import React, { useContext } from "react";
import style from "./index.module.scss";
import ListItem from "./components/ListItem";
import useRequest from "Utils/useRequest";
import { getStuSignInList } from "API/signIn";
import { CourseContext } from "../Store";
import { Spin } from "antd";
import CustomEmpty from "components/CustomEmpty";

export default function SignIn() {
    const { course } = useContext(CourseContext);
    const [list, { loading }] = useRequest(() =>
        getStuSignInList(course.weekTimeId)
    );

    return (
        <div className={style.root}>
            <div className={style.count}>签到活动（{list?.length || 0}）</div>

            <Spin spinning={loading}>
                {list?.map(item => (
                    <ListItem key={item.id} data={item} />
                ))}

                {!list?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
